// src/data/data.js

export const reinvestmentRate = {
  labels: ["2025-03-10", "2025-03-11", "2025-03-12"],
  fees: [1200, 900, 1600],
  reinvested: [1080, 720, 1520],
};



// Central place to tweak boost stats (easy to update without touching components)
export const boosts = {
  count: 100,                                   // total boosts purchased
  lastBoostAt: "2025-10-27T11:00:00Z",        // ISO timestamp of last boost
  totalSpentUsd: 420,                          // optional: total USD spent on boosts
  history: [
    // optional: for future charts
    // { at: "2025-10-20T14:10:00Z", amountUsd: 60 },
    // { at: "2025-10-22T18:30:00Z", amountUsd: 120 },
  ],
};

export const boostsHistory = {
  labels: [
    "2025-10-21",
    "2025-10-22",
    "2025-10-23",
    "2025-10-24",
    "2025-10-25",
  ],
  values: [2, 1, 3, 0, 2],
};

// src/data/data.js
export const communityHistory = [
  // Keep newest at the END. One row per day.
  // date = ISO string or simple "YYYY-MM-DD"
  { date: "2025-03-10", followers: 120 },
  { date: "2025-03-11", followers: 135 },
  { date: "2025-03-12", followers: 170 },
  // append a new row each day:
  // { date: "2025-03-13", followers: 205 },
];



export const dataJSON = {
  stats: {
    won: 16,
    lost: 16,
    push: 1,
    winrate: 50,
    averageodds: 1.87,
    profit: 45850,
    loss: -51400,
    netresult: -5550,
  },
  bets: {
    5000: {
      Date: '14.09.2022',
      League: 'Dex Boost',
      'Pick of the day': 'Dexscreener Boosts',
      Link: '',
      Game: 'Amplify $CYCLE presence on DEX Screener',
      Dime: '50',
      Allocation: '499',
      Odds: '',
      Won: '',
      Lost: '',
      Push: '',
      Livescore: '',
      Finished: '',
      TimestampUTC: '',
        },
  },
  last: {
    Date: '11.10.2022',
    League: 'NFL',
    'Pick of the day': 'Over 51.5',
    Link: 'https://t.me/BetcoinBets/210',
    Game: 'Kansas City Chiefs vs Las Vegas Raiders',
    Dime: 50,
    Allocation: 2500,
    'Net Return': 2300,
    Odds: 1.92,
    Won: 1,
    Lost: 0,
    Push: '',
    Livescore: 'https://www.flashscore.com/match/IaytUPqU/#/match-summary',
    Finished: '1',
    TimestampUTC: 1665447300,
  },
  winrate: {
    labels: [
      '2022-09-30 12:00:00',
      '2022-10-01 12:00:00',
      '2022-10-02 12:00:00',
      '2022-10-03 12:00:00',
      '2022-10-04 12:00:00',
      '2022-10-05 12:00:00',
      '2022-10-06 12:00:00',
      '2022-10-07 12:00:00',
      '2022-10-08 12:00:00',
      '2022-10-10 12:00:00',
      '2022-10-11 12:00:00',
    ],
    values: [62.5, 58.82, 57.89, 52.38, 52.17, 50, 53.85, 55.56, 51.72, 50, 50],
  },
  netreturn: {
    labels: [
      '2022-09-30 12:00:00',
      '2022-10-01 12:00:00',
      '2022-10-02 12:00:00',
      '2022-10-03 12:00:00',
      '2022-10-04 12:00:00',
      '2022-10-05 12:00:00',
      '2022-10-06 12:00:00',
      '2022-10-07 12:00:00',
      '2022-10-08 12:00:00',
      '2022-10-10 12:00:00',
      '2022-10-11 12:00:00',
    ],
    values: [3400, -3000, 2000, -10500, -1100, -3000, 1700, 2600, -2500, -9740, -200],
  },
};

export const buybackJSON = {
  buyback: 3926790.061496461,
  percentage: 3.926790061496461,
  price: 0.0288621978626034,
  change: '-24.22%',
  value: 113335.79171981543,
  buybacks: {
    labels: [
      '2022-09-11 12:00:00',
      '2022-09-12 12:00:00',
      '2022-09-13 12:00:00',
      '2022-09-14 12:00:00',
      '2022-09-15 12:00:00',
      '2022-09-16 12:00:00',
      '2022-09-17 12:00:00',
      '2022-09-19 12:00:00',
      '2022-09-20 12:00:00',
      '2022-09-21 12:00:00',
      '2022-09-22 12:00:00',
      '2022-09-23 12:00:00',
      '2022-09-24 12:00:00',
      '2022-09-25 12:00:00',
      '2022-09-26 12:00:00',
      '2022-09-27 12:00:00',
      '2022-09-29 12:00:00',
      '2022-09-30 12:00:00',
      '2022-10-01 12:00:00',
      '2022-10-02 12:00:00',
      '2022-10-03 12:00:00',
      '2022-10-04 12:00:00',
      '2022-10-05 12:00:00',
      '2022-10-06 12:00:00',
      '2022-10-07 12:00:00',
      '2022-10-10 12:00:00',
      '2022-10-11 12:00:00',
    ],
    values: [
      459514.96115632297, 161271.3579596454, 113618.49116691622, 52359.56903881099, 24759.116726930613,
      20025.634771565656, 11294.58484484059, 189282.36509396954, 190757.1017940857, 168122.66140548285,
      246164.17158821147, 306475.0909720561, 112585.05164708318, 36535.978977598985, 417383.80264913494,
      37121.9300566885, 49374.749939241636, 141172.08443339364, 29173.66458477447, 317022.8542585656,
      114278.87463037319, 34759.26098463549, 316635.195748636, 69333.11246322244, 70942.59181868544, 152358.69997785776,
      84467.10280773137,
    ],
  },
};

export const communityJSON = {
  stats: {
    won: 5,
    lost: 13,
    push: 0,
    winrate: 27.78,
    averageodds: 4.1,
    profit: 9800,
    loss: -6000,
    netresult: 3800,
  },
  bets: {
    5000: {
      Date: '25.09.2022',
      League: 'NFL',
      'Pick of the day': 'Baltimore Ravens (-3) / Cincinnati Bengals (-4)',
      Link: 'https://t.me/BetcoinBets/105',
      Game: 'New England Patriots vs Baltimore Ravens / New York Jets vs Cincinnati Bengals',
      Dime: 0,
      Allocation: 1500,
      'Net Return': 3500,
      Odds: 3.35,
      Won: 1,
      Lost: 0,
      Push: '',
      Livescore: '',
      Finished: '1',
      TimestampUTC: 1664125200,
    },
    4999: {
      Date: '26.09.2022',
      League: 'NFL',
      'Pick of the day': 'San Francisco 49ers (-1.5)',
      Link: 'https://t.me/BetcoinBets/109',
      Game: 'Denver Broncos vs San Francisco 49ers',
      Dime: 0,
      Allocation: 1500,
      'Net Return': -1500,
      Odds: 1.89,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: '',
      Finished: '1',
      TimestampUTC: 1664151600,
    },
    4998: {
      Date: '26.09.2022',
      League: 'UEFA',
      'Pick of the day': 'England',
      Link: 'https://t.me/BetcoinBets/114',
      Game: 'England vs Germany',
      Dime: 0,
      Allocation: 1000,
      'Net Return': -1000,
      Odds: 2.41,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: '',
      Finished: '1',
      TimestampUTC: 1664217900,
    },
    4997: {
      Date: '28.09.2022',
      League: 'MLB',
      'Pick of the day': 'ATL Braves (-1.5) / Daniel Lynch (KC Royals) - Under 5.5 / Luis Cessa ( CIN Reds) - Over 2.5',
      Link: 'https://t.me/BetcoinBets/123',
      Game: 'WAS Nationals vs ATL Braves / DET Tigers vs KC Royals / PIT Pirates vs CIN Reds',
      Dime: 0,
      Allocation: 500,
      'Net Return': 0,
      Odds: 4.55,
      Won: 0,
      Lost: 0,
      Push: '',
      Livescore: '',
      Finished: '1',
      TimestampUTC: 1664382900,
    },
    4996: {
      Date: '30.09.2022',
      League: 'MLB',
      'Pick of the day': 'Cleveland Guardians WIN / Los Angeles Dodgers WIN',
      Link: 'https://t.me/BetcoinBets/130',
      Game: 'Cleveland Guardians vs Tampa Bay Rays / San Diego Padres vs Los Angeles Dodgers',
      Dime: 0,
      Allocation: 1000,
      'Net Return': 2800,
      Odds: 3.84,
      Won: 1,
      Lost: 0,
      Push: '',
      Livescore: '',
      Finished: '1',
      'Total Won': 'Profit',
      'Total Lost': 'Loss',
      TimestampUTC: 1664489400,
    },
    4995: {
      Date: '30.09.2022',
      League: '-',
      'Pick of the day':
        'PEC Zwolle vs Jong Ajax Amsterdam (Over 3.5) / FC Bayern Munich WIN / Standard Liege WIN / Olimpique Marseille WIN',
      Link: 'https://t.me/BetcoinBets/136',
      Game: 'PEC Zwolle vs Jong Ajax Amsterdam / FC Bayern Munich vs Bayer 04 Leverkusen / Standard Liege vs RFC Seraing / Angers SCO vs Olympigue Marseille',
      Dime: 0,
      Allocation: 500,
      'Net Return': -500,
      Odds: 6.67,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/fqL7WBrH/#/match-summary',
      Finished: '1',
      TimestampUTC: 1664562600,
    },
    4994: {
      Date: '01.10.2022',
      League: 'MLB',
      'Pick of the day': 'New York Yankees WIN / Toronto Blue Jays WIN',
      Link: 'https://t.me/BetcoinBets/142',
      Game: 'New York Yankees vs Baltimore Orioles / Toronto Blue Jays vs Boston Red Sox',
      Dime: 0,
      Allocation: 1000,
      'Net Return': -1000,
      Odds: 2.48,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/vohpDKjp/#/match-summary',
      Finished: '1',
      TimestampUTC: 1664579100,
    },
    4993: {
      Date: '01.10.2022',
      League: 'CL',
      'Pick of the day': 'AC Milan WIN / Paris Saint-Germain WIN',
      Link: 'https://t.me/BetcoinBets/144',
      Game: 'FC Empoli vs AC Milan / Paris Saint-Germain vs OGC Nice',
      Dime: 0,
      Allocation: 1000,
      'Net Return': 1000,
      Odds: 2.03,
      Won: 1,
      Lost: 0,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/d8NmYvDH/#/match-summary',
      Finished: '1',
      'Total Won': 'Net Return',
      TimestampUTC: 1664649900,
    },
    4992: {
      Date: '02.10.2022',
      League: 'NFL',
      'Pick of the day': 'Arizona Cardinals WIN / Kansas City Chiefs WIN',
      Link: 'https://t.me/BetcoinBets/159',
      Game: 'Carolina Panthers vs Arizona Cardinals / Tampa Bay Buccaneers vs Kansas City Chiefs',
      Dime: 0,
      Allocation: 1000,
      'Net Return': 3000,
      Odds: 4.06,
      Won: 1,
      Lost: 0,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/KtRIGF9D/#/match-summary',
      Finished: '1',
      TimestampUTC: 1664741100,
    },
    4991: {
      Date: '04.10.2022',
      League: 'Champions League',
      'Pick of the day': 'Barcelona WIN / Ajax vs Napoli (Over 2.5) / Atletico Madrid WIN',
      Link: 'https://t.me/BetcoinBets/173',
      Game: 'Inter Milan vs Barcelona / Ajax vs Napoli / Club Brugge vs Atletico Madrid',
      Dime: 0,
      Allocation: 500,
      'Net Return': -500,
      Odds: 5.6,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/football/europe/champions-league/',
      Finished: '1',
      TimestampUTC: 1664910000,
    },
    4990: {
      Date: '05.10.2022',
      League: 'Champions League',
      'Pick of the day': 'Chelsea FC vs AC Milan (Over 2.5) / Paris Saint-Germain FC WIN',
      Link: 'https://t.me/c/1726996880/138751',
      Game: 'Chelsea FC vs AC Milan / SL Benfica vs Paris Saint-Germain FC',
      Dime: 0,
      Allocation: 1000,
      'Net Return': -1000,
      Odds: 3.48,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/4GswEfPe/#/match-summary/match-summary',
      Finished: '1',
      TimestampUTC: 1664996400,
    },
    4989: {
      Date: '06.10.2022',
      League: '',
      'Pick of the day': 'SC Braga WIN / Denver Broncos vs Indianapolis Colts (Under 23.5) / Philadelphia Phillies',
      Link: 'https://t.me/BetcoinBets/184',
      Game: 'SC Braga vs Union Saint-Gilloise / Denver Broncos vs Indianapolis Colts / St. Louis Cardinals vs Philadelphia Phillies',
      Dime: 0,
      Allocation: 500,
      'Net Return': -500,
      Odds: 5.34,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/vuHW43CF/#/match-summary/match-summary',
      Finished: '1',
      TimestampUTC: 1665082800,
    },
    4988: {
      Date: '09.10.2022',
      League: 'NFL',
      'Pick of the day':
        'Los Angeles Chargers WIN / Jacksonville Jaguars (-6.5) / Arizona Cardinals vs Philadelphia Eagles (Over 48.5)',
      Link: 'https://t.me/BetcoinBets/199',
      Game: 'Cleveland Browns vs Los Angeles Chargers / Jacksonville Jaguars vs Houston Texans / Arizona Cardinals vs Philadelphia Eagles',
      Dime: 0,
      Allocation: 280,
      'Net Return': -280,
      Odds: 6.43,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/american-football/usa/nfl/',
      Finished: '1',
      TimestampUTC: 1665334800,
    },
    4987: {
      Date: '09.10.2022',
      League: 'NFL',
      'Pick of the day':
        'Minnesota Vikings vs Chicago Bears (Over 44.5) / Carolina Panthers vs San Francisco 49ers (Under 41.5)',
      Link: 'https://t.me/BetcoinBets/200',
      Game: 'Minnesota Vikings vs Chicago Bears / Carolina Panthers vs San Francisco 49ers',
      Dime: 0,
      Allocation: 840,
      'Net Return': -840,
      Odds: 3.43,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/american-football/usa/nfl/',
      Finished: '1',
      TimestampUTC: 1665334800,
    },
    4986: {
      Date: '09.10.2022',
      League: 'NFL',
      'Pick of the day': 'Tampa Bay Buccaneers (-7.5) / Minnesota Vikings vs Chicago Bears (Over 43.5)',
      Link: 'https://t.me/BetcoinBets/198',
      Game: 'Tampa Bay Buccaneers vs Atlanta Falcons / Minnesota Vikings vs Chicago Bears',
      Dime: 0,
      Allocation: 280,
      'Net Return': -280,
      Odds: 3.16,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/fLjGZTFh/#/match-summary/match-summary',
      Finished: '1',
      TimestampUTC: 1665334800,
    },
    4985: {
      Date: '09.10.2022',
      League: 'NFL',
      'Pick of the day': 'Seattle Seahawks WIN / Detroit Lions (+3.5)',
      Link: 'https://t.me/BetcoinBets/198',
      Game: 'New Orleans Saints vs Seattle Seahawks / New England Patriots vs Detroit Lions',
      Dime: 0,
      Allocation: 280,
      'Net Return': -280,
      Odds: 5.13,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/american-football/usa/nfl/',
      Finished: '1',
      TimestampUTC: 1665334800,
    },
    4984: {
      Date: '09.10.2022',
      League: 'NFL',
      'Pick of the day': 'Los Angeles Chargers WIN / Minnesota Vikings (-7.5)',
      Link: 'https://t.me/BetcoinBets/198',
      Game: 'Cleveland Browns vs Los Angeles Chargers / Minnesota Vikings vs Chicago Bears',
      Dime: 0,
      Allocation: 280,
      'Net Return': -280,
      Odds: 3.37,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/american-football/usa/nfl/',
      Finished: '1',
      TimestampUTC: 1665334800,
    },
    4983: {
      Date: '09.10.2022',
      League: 'NFL',
      'Pick of the day': 'Dallas Cowboys (+6) / Cincinnati Bengals (+3)',
      Link: 'https://t.me/BetcoinBets/198',
      Game: 'Los Angeles Rams vs Dallas Cowboys / Baltimore Ravens vs Cincinnati Bengals',
      Dime: 0,
      Allocation: 280,
      'Net Return': 700,
      Odds: 3.53,
      Won: 1,
      Lost: 0,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/O0rXVoFH/#/match-summary',
      Finished: '1',
      TimestampUTC: 1665347100,
    },
    4982: {
      Date: '10.10.2022',
      League: 'NFL',
      'Pick of the day': 'Cincinnati Bengals',
      Link: 'https://t.me/BetcoinBets/198',
      Game: 'Baltimore Ravens vs Cincinnati Bengals',
      Dime: 0,
      Allocation: 280,
      'Net Return': -280,
      Odds: 2.43,
      Won: 0,
      Lost: 1,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/zynyV5UN/#/match-summary',
      Finished: '1',
      TimestampUTC: 1665361200,
    },
    4981: {
      Date: '11.10.2022',
      League: 'NFL',
      'Pick of the day': 'Kansas City Chiefs WIN and Over 51.5',
      Link: 'https://t.me/BetcoinBets/203',
      Game: 'Kansas City Chiefs vs Las Vegas Raiders',
      Dime: 0,
      Allocation: 700,
      'Net Return': 0,
      Odds: 2.48,
      Won: 0,
      Lost: 0,
      Push: '',
      Livescore: 'https://www.flashscore.com/match/IaytUPqU/#/match-summary',
      TimestampUTC: 1665447300,
    },
  },
  last: {
    Date: '11.10.2022',
    League: 'NFL',
    'Pick of the day': 'Kansas City Chiefs WIN and Over 51.5',
    Link: 'https://t.me/BetcoinBets/203',
    Game: 'Kansas City Chiefs vs Las Vegas Raiders',
    Dime: 0,
    Allocation: 700,
    'Net Return': 0,
    Odds: 2.48,
    Won: 0,
    Lost: 0,
    Push: '',
    Livescore: 'https://www.flashscore.com/match/IaytUPqU/#/match-summary',
    TimestampUTC: 1665447300,
  },
};
